import React, { useEffect } from "react";
import { Layout } from "antd";
import { Route, Routes, useNavigate } from "react-router-dom";
// import IMS from "../IMS";
// import Production from "../Production";
import SidebarComponent from "./sidebar";
import UserManager from "../UserManager";
import ProjectStatuses from "../ProjectStatuses";
import DocumentControl from "../DocumentControl";
import RevisionStatuses from "../RevisionStatuses";
// import ClientsManager from "../ClientsManager";
import ProjectsSetup from "../ProjectSetup";
// import UserTypes from "../UserTypes";
import Departments from "../ActivityTypes";
import Commodity from "../commodity";
import Supplier from "../supplier";
import MaterialTypes from "../materialTypes";
import LocationManager from "../LocationManager";
import "./index.less";
import UserDetails from "../UserManager/userDetails";
// import ClientDetails from "../ClientsManager/clientDetails";
import axios from "axios";
import { baseURL } from "../../globalUtils/axiosConfig";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../login/redux/actions";
import ProjectDetail from "../ProjectSetup/projectDetail/index.jsx";
import TemplateCreation from "../materialTemplates/materialTemplateCreate/index.jsx";
import Projects from "../Projects";
import ProgressSummary from "../ProgressSummary";
import MaterialTemplates from "../materialTemplates";
import DeliveryNoteRegister from "../DeliveryNoteRegister";

const LayoutComponent = () => {
  const { Content } = Layout;
  const { user } = useSelector((state) => state.authReducer);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const validateUser = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/api/v1/users/check_user_token`
        );
        const { success } = response.data;
        if (success) {
          dispatch(
            actions.loginUserSuccess({
              user: response.data.data,
              navigate,
              shouldNavigate: false,
            })
          );
        }
        if (!success) {
          dispatch(actions.logoutUserSuccess(response.data.data));
        }
      } catch (error) {
        console.log(error);
      }
    };
    // validateUser();
  }, []);

  return (
    <Layout className="most-parent-layout">
      <Layout className="site-layout">
        <SidebarComponent />
        <Content className="layout-content site-layout-background custom-textarea">
          <Routes>
            <Route
              path="/project/material-control/:project_id"
              element={<Projects />}
            />
            <Route
              path="/project/delivery-notes/:project_id"
              element={<DeliveryNoteRegister />}
            />
            <Route
              path="/project/delivery-notes/:project_id/create"
              element={<DeliveryNoteRegister />}
            />
            <Route
              path="/project/delivery-notes/:project_id/update/:id"
              element={<DeliveryNoteRegister />}
            />
            <Route
              path="/project/progress-summary/:project_id"
              element={<ProgressSummary />}
            />
            <Route
              path="/projects/material-control"
              element={<DocumentControl />}
            />
            {user?.permissions?.user_manager?.view && (
              <>
                <Route
                  path="/settings/users-manager"
                  element={<UserManager />}
                />
                <Route
                  path="/settings/users-manager/create-user"
                  element={<UserDetails />}
                />
                <Route
                  path="/settings/users-manager/update-user/:id"
                  element={<UserDetails />}
                />
              </>
            )}
            {user?.permissions?.commodity?.view && (
              <Route
                path="/settings/commodity"
                element={<Commodity />}
              />
            )}
            {user?.permissions?.material_templates?.view && (
              <>
              <Route
                path="/settings/material-templates"
                element={<MaterialTemplates />}
              />
              <Route
                path="/settings/material-templates/create-template"
                element={<TemplateCreation />}
              />
              <Route
                path="/settings/material-templates/update-template/:id"
                element={<TemplateCreation />}
              />
            </>
              
            )}
            {user?.permissions?.material_types?.view && (
              <Route
                path="/settings/material-types"
                element={<MaterialTypes />}
              />
            )}
            {user?.permissions?.project_statuses?.view && (
              <Route
                path="/settings/project-statuses"
                element={<ProjectStatuses />}
              />
            )}
            {user?.permissions?.supplier?.view && (
              <Route
                path="/settings/supplier"
                element={<Supplier />}
              />
            )}
            <Route path="/profile" element={<UserDetails />} />

            {user?.permissions?.departments?.view && (
              <Route path="/settings/departments" element={<Departments />} />
            )}
            {user?.permissions?.locations?.view && (
              <>
                <Route path="/settings/locations" element={<LocationManager />} />
                <Route path="/settings/locations/create-location" element={<LocationManager />} />
                <Route path="/settings/locations/update-location/:id" element={<LocationManager />} />
              </>
            )}
            {user?.permissions?.project_setup?.view && (
              <>
                <Route path="/projects-setup" element={<ProjectsSetup />} />
                <Route
                  path="/projects-setup/create-project"
                  element={<ProjectDetail />}
                />
                <Route
                  path="/projects-setup/update-project/:id"
                  element={<ProjectDetail />}
                />
              </>
            )}
          </Routes>
        </Content>
      </Layout>
    </Layout>
  );
};

export default LayoutComponent;
